import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import Newsletter from "../components/site/home/Newsletter";
import Breadcrumbs from "../components/site/Breadcrumbs";
import { useSeo } from "../hooks/useSeo";
import { GUIDES } from "../data/sitePages";
import { photoFromPool } from "../data/themePhotos";
import { track } from "../lib/analytics";

export default function Guides() {
  const navigate = useNavigate();
  const crumbs = [{ name: "Home", path: "/" }, { name: "Guides", path: "/guides" }];

  // All guides are "coming soon" — keep the hub noindex until articles publish.
  useSeo({
    title: "Guides (Coming Soon) | YogaToYacht",
    description: "In-depth YogaToYacht guides to choosing yoga, wellness, sailing and yacht retreats — coming soon.",
    path: "/guides",
    noindex: true,
  });

  return (
    <div data-testid="guides-page" className="bg-brand-bg text-brand-ink">
      <Header onNavigate={() => navigate("/")} />
      <section className="mx-auto max-w-[1400px] px-6 pt-40 pb-12 md:px-10">
        <Breadcrumbs items={crumbs} />
        <p className="overline mt-6 text-brand-inkSoft">Guides &amp; blog</p>
        <h1 className="mt-3 font-display text-4xl leading-tight text-brand-ink md:text-6xl">Retreat guides</h1>
        <p className="mt-5 max-w-2xl text-lg text-brand-inkSoft">
          Plain-English help for choosing the right escape. These guides are being written now —
          join the list and we&apos;ll tell you the moment each one is published.
        </p>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 pb-24 md:px-10">
        <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 lg:grid-cols-4">
          {GUIDES.map((g, i) => (
            <Link key={g.slug} to={`/guides/${g.slug}`} onClick={() => track("guide_card_clicked", { slug: g.slug, title: g.title })} data-testid={`guides-card-${g.slug}`} className="group block fade-up" style={{ animationDelay: `${i * 60}ms` }}>
              <div className="card-img-wrap img-gradient-overlay relative aspect-[3/4] w-full bg-brand-bg2">
                <img src={photoFromPool(g.theme, i + 2)} alt={g.title} loading="lazy" className="card-img absolute inset-0 h-full w-full object-cover" />
                <span className="absolute left-4 top-4 z-10 inline-flex items-center gap-1.5 rounded-full bg-white/90 px-3 py-1 text-[11px] font-medium text-brand-ink"><Clock size={12} /> Coming soon</span>
              </div>
              <h2 className="mt-4 flex items-start justify-between gap-2 px-1 font-display text-lg leading-snug text-brand-ink">
                {g.title}
                <ArrowUpRight size={16} className="mt-1 shrink-0 text-brand-terracotta transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </h2>
            </Link>
          ))}
        </div>
      </section>

      <Newsletter />
      <Footer />
    </div>
  );
}
